import { makeStyles } from '@material-ui/core/styles';

const useTableBodyStyles = makeStyles({
  clickable: {
    cursor: 'pointer',
  },
});
export { useTableBodyStyles };
